export default "__VITE_ASSET__Dc2hfh_A__"